(function (root) {
  const id = (value) => String(value || '').split('/').pop();
  function plan(config, selected) {
    const media = config.media.map((item, index) => ({ ...item, id: id(item.id), index }));
    if (config.linkedProducts) return { visible: media.map((item) => item.id), hidden: [], complete: true };
    const anchors = new Map();
    for (const color of config.colors || []) {
      if (color.anchor) {
        const key = id(color.anchor);
        if (!anchors.has(key)) anchors.set(key, new Set());
        anchors.get(key).add(color.name);
      }
    }
    const multi = (config.colors || []).length > 1;
    const complete = !multi || config.colors.every((color) => color.anchor && media.some((item) => item.id === id(color.anchor)));
    const firstAnchor = media.findIndex((item) => anchors.has(item.id));
    const selectedItems = [], shared = [], hidden = [];
    let group = null;
    for (const item of media) {
      if (anchors.has(item.id)) group = anchors.get(item.id);
      const filename = (item.src || '').split('?')[0].split('/').pop().toLowerCase();
      const guide = /(?:^|[-_])(size[-_]?guide|size[-_]?chart|wrist|length|fit[-_]?guide|find[-_]apple[-_]watch[-_]size|compatibility)(?:[-_.]|$)/.test(filename);
      if (guide) shared.push(item.id);
      else if (multi && firstAnchor >= 0 && item.index < firstAnchor) shared.push(item.id);
      else if (!multi || !complete || !selected || !group || group.has(selected)) selectedItems.push(item.id);
      else hidden.push(item.id);
    }
    const visible = [...selectedItems, ...shared];
    const firstTwo = new Set(media.slice(0, 2).map((item) => item.id));
    return { visible: [...visible.filter((key) => !firstTwo.has(key)), ...visible.filter((key) => firstTwo.has(key))], hidden, complete };
  }
  root.OribandGalleryCore = { plan };
  if (typeof module !== 'undefined') module.exports = { plan };
})(globalThis);
